import { render, staticRenderFns } from "./LeoOrderNew.vue?vue&type=template&id=c2e52e14&scoped=true&"
import script from "./LeoOrderNew.vue?vue&type=script&lang=js&"
export * from "./LeoOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./LeoOrderNew.vue?vue&type=style&index=0&id=c2e52e14&lang=less&scoped=scoped&"
import style1 from "./LeoOrderNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e52e14",
  null
  
)

export default component.exports